import axios from 'axios';

import { PurchaseStatus } from '../components/Shops/shared/__providers__/PurchaseStatusProvider';

export const requestPaymentIntent = (payload: any): Promise<any> =>
  axios.post('v1/web/purchases', JSON.stringify(payload));

export const requestCouponPaymentIntent = (payload: any): Promise<any> =>
  axios.post('v1/tips/web/purchases', JSON.stringify(payload));

export const requestPaymentVerification = (payload: any) => {
  return axios.post('v1/purchases', JSON.stringify(payload));
};

export const requestPremiumPaymentIntent = (payload: any): Promise<any> =>
  axios.post('v1/premium/web/purchases', payload.toJSON());

export const requestPremiumPaymentVerification = async (purchaseID: string) => {
  try {
    await axios.post(`v1/premium/web/purchases/${purchaseID}/confirm`);
    return 200;
  } catch (e: any) {
    return e;
  }
};

export const requestTipPaymentVerification = async (purchaseID: string) => {
  try {
    const response = await axios.post(
      `v1/tips/web/purchases/${purchaseID}/confirm`,
    );
    if (response) return response;
  } catch (e: any) {
    return e;
  }
};

export const requestPremiumPixPaymentVerification = (
  purchaseID: string | null,
): Promise<any | PixVerificationResponse> => {
  return axios.get(`v1/premium/purchases/${purchaseID}`);
};

export interface PixVerificationResponse {
  purchase: {
    state: PurchaseStatus;
  };
}

export const requestCouponPixPaymentVerification = (
  purchaseID: string | null,
): Promise<any> => {
  return axios.get(`v1/tips/purchases/${purchaseID}`);
};

export const requestFreeTipPurchase = (tipID: string, couponID: string) => {
  return axios.put(
    `v1/tips/${tipID}/unlock`,
    JSON.stringify({ coupon_id: couponID }),
  );
};
